<template>
  <a-card
    v-if="customAttributesEntries.length > 0"
    title="Información adicional"
    bodyStyle="padding: 0px;"
    :bordered="false"
  >
    <a-descriptions :column="1" bordered>
      <a-descriptions-item
        v-for="[key, value] in customAttributesEntries"
        :key="key"
        :label="key"
      >
        {{ displayValue(value) }}
      </a-descriptions-item>
    </a-descriptions>
  </a-card>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const displayValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

const props = defineProps({
  employee: {
    type: Object,
    default: () => ({})
  }
});

const customAttributesEntries = computed(() =>
  Object.entries(props.employee?.customAttributes ?? {})
);
</script>
